import React from "react";
import { isEqual } from "lodash";
import PerfectScrollbar from "react-perfect-scrollbar";
import { plural } from "../../utilities";
import { isoCountries } from "../../constants";
import { Row, Col, Input, InputGroup, InputGroupText } from "reactstrap";
/* eslint-disable */

class SearchFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      filters: [],
    };
  }

  componentWillMount() {
    const { filters } = this.props;
    this.setState({ filters });
  }

  componentDidUpdate({ filters }) {
    if (!isEqual(filters, this.props.filters)) {
      this.setState({ filters, search: "" });
    }
  }

  update = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, this._buildList);
  };

  showAll = () => {
    const { filters } = this.props;
    this.setState({ filters });
  };

  _buildList() {
    this.setState({ filters: this._filters() });
  }

  _filters() {
    const { filters } = this.props;
    const { search } = this.state;
    if (!search) return filters;
    return filters.filter((option) =>
      (isoCountries[option] || option)
        .toUpperCase()
        .includes(search.toUpperCase())
    );
  }

  render() {
    const { updateFilters, selectedFilters, name } = this.props;
    const { search, filters } = this.state;
    return (
      <>
        <InputGroup>
          <Input
            placeholder={`Search ${plural(name)}`}
            name="search"
            value={search}
            onChange={this.update}
          />
        </InputGroup>
        {/* <div className="filter-options" style={{ overflowX: 'hidden' }}> */}
        <PerfectScrollbar
          className="main-menu-content pe-1 ps-1"
          options={{ wheelPropagation: true }}
          style={{
            maxHeight: "calc((20vh - 0px) - 5px)",
            minScrollbarLength: 0,
          }}
        >
          {filters.map((filter) => (
            <label key={filter} className="filter">
              <input
                type="checkbox"
                value={filter}
                checked={selectedFilters.includes(filter)}
                onChange={updateFilters}
              />{" "}
              <SearchTarget
                search={search}
                text={isoCountries[filter] || filter}
              />
            </label>
          ))}
        </PerfectScrollbar>
        {/* </div> */}
      </>
    );
  }
}

export const SearchTarget = ({ search, text }) => {
  const regex = new RegExp(search, "gi");
  const match = regex.exec(text);
  if (!match) return <span>{text}</span>;
  return (
    <span className="transcript">
      <span>{text.slice(0, match.index)}</span>
      <span className="highlighted" style={{ color: "red" }}>
        {match[0]}
      </span>
      <span>{text.slice(regex.lastIndex)}</span>
    </span>
  );
};

export default SearchFilters;
